// Vendored from quill-languagetool v1.0.7 — adapted for Quill v2
// Key change: replaced nanohtml with standard DOM creation

import type { QuillLanguageTool } from "./index";

/**
 * Manager for the loading indicator.
 * This handles showing and hiding the loading indicator in the editor.
 */
export default class LoadingIndicator {
  private currentLoader?: HTMLElement;

  constructor(private readonly parent: QuillLanguageTool) {}

  public startLoading() {
    this.currentLoader?.remove();

    if (this.parent.params.showLoadingIndicator) {
      const loadingIndicator = document.createElement("div");
      loadingIndicator.className = "quill-lt-loading-indicator";

      const spinner = document.createElement("div");
      spinner.className = "quill-lt-loading-indicator-spinner";
      loadingIndicator.appendChild(spinner);

      this.currentLoader = loadingIndicator;
      this.parent.quill.root.parentElement?.appendChild(loadingIndicator);
    }
  }

  public stopLoading() {
    this.currentLoader?.remove();
  }
}
